
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quan-he-co-dong",
      function () {
        return require("private-next-pages/quan-he-co-dong/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quan-he-co-dong"])
      });
    }
  